import React, { Component } from 'react'
import Footer from './Footer.jsx'

import './home/css/bootstrap.css'
import './home/css/fontawesome-all.css'
import './home/css/styles.css'
import "bootstrap/dist/css/bootstrap.min.css"

// import logo from './home/images/logo.png'

class Terms extends Component {
  render() {
    return (
      <div>


        <header id="header" className="ex-header">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h1>Terms & Conditions</h1>
              </div>
            </div>
          </div>
        </header>

        <div className="ex-basic-1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="breadcrumbs">
                  <a href="/">Home</a><i className="fa fa-angle-double-right"></i><span>Terms &
                                Conditions</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ex-basic-2">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">

                <div className="text-container">
                  <h3>General Membership Info</h3>
                  <p>Welcome to SeatStir.com. If you continue to browse and use this website you are agreeing to comply with and be bound by the following Terms and Conditions of use, which, together with our privacy policy, govern SEATSTIR.COM’s relationship with you regarding your use of this website.
                  The term ‘SEATSTIR.COM’ or ‘us’ or ‘we’ refers to the owner of the website. The term ‘you’ refers to the user or viewer of our website.
                  The use of this website is subject to the following terms of use:
                  The content of the pages of this website is for your general information and use only. It is subject to change without notice.
                  Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials found or offered on this website for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.
                  Your use of any information or materials on this website is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services or information available through this website meet your specific requirements.
                  This website contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.
                  All trademarks reproduced in this website, which are not the property of, or licensed to the operator, are acknowledged on the website.
                  Unauthorized use of this website may give rise to a claim for damages and/or be a criminal offense.
                  From time to time, this website may also include links to other websites. These links are provided for your convenience to provide further information. They do not signify that we endorse the website(s). We have no responsibility for the content of the linked website(s).
                  You may not create a link to this website from another website or document without SEATSTIR.COM’s prior written consent.
                  </p>
                  <p>If ever you have a problem or dispute regarding your membership, we kindly ask that you send us an email at info@SEATSTIR.COM explaining your position. We will do all we can to resolve the issue. Customer service is our #1 priority at SEATSTIR.COM. Note that if you request a chargeback on your credit card for your membership fee(s) after seeing one or more events, SEATSTIR.COM will calculate the value of all the tickets you reserved at their full retail price as charged to the public and we will issue you a bill for that amount.
                  <br />
                    <h4 className="collectInfoHead">How We Use the Information We Collect</h4></p>
                  <ul className="list-unstyled li-space-lg indent">
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">Provide services and customer support;</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">Process transactions and send notices about your transactions;</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">Resolve disputes, collect fees, and troubleshoot problems;</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">Prevent potentially prohibited or illegal activities, and enforce our User Agreement;</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">Customize, measure, and improve SeatStir.com Services and the content, layout, and operation of our websites and applications;</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">Deliver targeted marketing, service update notices, and promotional offers based on your communication preferences;</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">Contact you at any telephone number, by placing a voice call or through text (SMS) or email messaging, as authorized by our User Agreement;</div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">Compare information for accuracy and verify it with third parties.</div>
                    </li>
                  </ul>
                </div>

                <div className="text-container">
                  <h3>Marketing</h3>
                  <p>We do not sell or rent your personal information to third parties for any
                  purposes without your explicit consent. We may provide your e-mail address
                  to a venue you have attended, only for the purpose of surveying your opinion
                  regarding your visit to the venue. We may combine your information with
                  information we collect from other companies and use it to improve and
                  personalize SeatStir.com services, content, and advertising. If you do
                  not wish to receive marketing communications from us or participate
                  in our ad-customization programs, simply indicate your preference by
                  logging into your account and going to the Notification section under
                  the Settings tab and updating your preferences, or by clicking the
                  Unsubscribe link provided within the communication or advertisement.
                  We respect your communication preferences. If you no longer wish to receive n
                  otifications via our mailing list, please click UNSUBSCRIBE on any mailing and
                  you will be removed instantly. If you have any issues with our communication,
                  notify us at info@seatstir.com. We may call or send a text message (SMS) to you
                  via the landline or mobile phone number that you have provided to us, in the
                      event that we need to reach you urgently.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

export default Terms